// This file is auto-generated by @hey-api/openapi-ts

import type { CancelablePromise } from './core/CancelablePromise';
import { OpenAPI } from './core/OpenAPI';
import { request as __request } from './core/request';
import { type GetApiBansGetBanStateResponse, GetApiBansGetBanStateResponseTransformer, type PostApiBfSaveData, type PostApiBfSaveResponse, type PostApiClicksMiningAndFeedingData, type PostApiClicksMiningAndFeedingResponse, type GetApiCoinsShopGetListingsResponse, type PostApiCoinsShopBuyItemData, type PostApiCoinsShopBuyItemResponse, type GetApiCoinsShopGetCoinsShopGrainResponse, type GetApiConnectSocialsGetConnectedSocialsResponse, type GetApiConnectSocialsIsTwitterConnectedResponse, type GetApiConnectSocialsConnectTwitterResponse, type GetApiConnectSocialsConnectTwitterCallbackData, type GetApiConnectSocialsConnectTwitterCallbackResponse, type GetApiConnectSocialsConnectDiscordResponse, type GetApiConnectSocialsConnectDiscordCallbackData, type GetApiConnectSocialsConnectDiscordCallbackResponse, type GetApiConnectSocialsIsDiscordConnectedResponse, type GetApiConnectSocialsConnectZephyrusResponse, type GetApiConnectSocialsConnectZephyrusCallbackData, type GetApiConnectSocialsConnectZephyrusCallbackResponse, type GetApiDailyStreakGetStateResponse, type PostApiDailyStreakClaimDailyBonusResponse, type PostApiDailyStreakDebugResetStreakResponse, type PostApiDailyStreakSetDebugModeData, type PostApiDailyStreakSetDebugModeResponse, GetApiDailyStreakGetStateResponseTransformer, type GetApiDebugPingPingResponse, type GetApiDebugErrorErrorResponse, type GetApiDebugRussianRouletteRussianRouletteResponse, type GetApiDebugGetDebutValuesResponse, type GetApiDebugIsAutoFeedStartedResponse, type PostApiDebugStartAutoFeedResponse, type PostApiDebugStopAutoFeedResponse, type PostApiDebugDebugClearDataResponse, type PostApiDebugDebugDeleteShopPurchasesResponse, type PostApiDebugDebugFakePurchaseResponse, type PostApiDebugDebugFakePurchaseItemData, type PostApiDebugDebugFakePurchaseItemResponse, type PostApiDebugDebugDestroyQuestsResponse, type PostApiDebugDebugCreateRefereeResponse, type PostApiDebugDebugDestroySocialConnectionsResponse, type PostApiDebugDebugResetCoinsResponse, type PostApiDebugDebugAddCoinsData, type PostApiDebugDebugAddCoinsResponse, type PostApiDebugDebugRechargeEnergyResponse, type PostApiDebugDebugAddShardsData, type PostApiDebugDebugAddShardsResponse, type PostApiDebugUpdateDebugConfigSkipOnboardingData, type PostApiDebugUpdateDebugConfigSkipOnboardingResponse, type GetApiDebugGetDebugConfigResponse, type PostApiDebugSendDebugNotificationResponse, GetApiDebugGetDebutValuesResponseTransformer, type GetApiEnergyBallsGetEnergyBallStateResponse, type PostApiEnergyBallsTakeHitsComboByBallIdData, type PostApiEnergyBallsTakeHitsComboByBallIdResponse, type PostApiEnergyBallsDebugResetResponse, type PostApiEnergyBallsDebugTakeHitsByBallIdData, type PostApiEnergyBallsDebugTakeHitsByBallIdResponse, type PostApiGameUpdateCoinsSnapshotResponse, type GetApiGameCoinsEarnedAwayResponse, type GetApiGameGetPlayerStateResponse, PostApiGameUpdateCoinsSnapshotResponseTransformer, GetApiGameGetPlayerStateResponseTransformer, type GetApiInventoryGetInventoryResponse, type PostApiInventoryEquipItemData, type PostApiInventoryEquipItemResponse, type PostApiInventoryUseItemData, type PostApiInventoryUseItemResponse, type PostApiInventoryUnequipHatResponse, type GetApiOnboardingGetOnboardingStateResponse, type PostApiOnboardingSelectStarterData, type PostApiOnboardingSelectStarterResponse, type PostApiOnboardingUpdateStepData, type PostApiOnboardingUpdateStepResponse, type PostApiOnboardingCompleteOnboardingResponse, type GetApiQuestsGetActiveQuestsResponse, type GetApiQuestsGetQuestByQuestIdData, type GetApiQuestsGetQuestByQuestIdResponse, type PostApiQuestsVerifyQuestByQuestIdData, type PostApiQuestsVerifyQuestByQuestIdResponse, type PostApiQuestsMoveQuestToVerifiableByQuestIdData, type PostApiQuestsMoveQuestToVerifiableByQuestIdResponse, GetApiQuestsGetActiveQuestsResponseTransformer, GetApiQuestsGetQuestByQuestIdResponseTransformer, type GetApiRaffleTicketsGetRaffleTicketsResponse, type GetApiRaffleTicketsGetTicketsSinceFirstSnapshotResponse, type PostApiRaffleTicketsUseRaffleTicketResponse, type GetApiReferralsGerReferralCodeResponse, type GetApiReferralsGetReferralsStateResponse, type GetApiReferralsGetRefereesData, type GetApiReferralsGetRefereesResponse, type GetApiReferralsGetRefereesCountResponse, type PostApiReincarnateReincarnateResponse, type GetApiShopInitiatePurchaseByListingIdData, type GetApiShopInitiatePurchaseByListingIdResponse, type GetApiShopGetShopListingsResponse, type GetApiShopGetBoosterShopListingsResponse, type GetApiSpecialSignupTicketsGetTicketCountResponse, type PostApiUpgradesBuyUpgradeData, type PostApiUpgradesBuyUpgradeResponse, type GetApiUpgradesGetPurchasableUpgradesResponse, type PostApiWalletsUpdateWalletData, type PostApiWalletsUpdateWalletResponse, type GetApiWildsCommunicationGetWildsSignedUrlResponse, type GetApiWildsCommunicationGetUserEggStatsResponse } from './types.gen';

export class BansService {
    /**
     * @returns PlayerBannedState OK
     * @throws ApiError
     */
    public static getBanState(): CancelablePromise<GetApiBansGetBanStateResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Bans/GetBanState',
            responseTransformer: GetApiBansGetBanStateResponseTransformer
        });
    }
    
}

export class BfService {
    /**
     * @param data The data for the request.
     * @param data.requestBody
     * @returns unknown OK
     * @throws ApiError
     */
    public static save(data: PostApiBfSaveData = {}): CancelablePromise<PostApiBfSaveResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Bf/Save',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
}

export class ClicksService {
    /**
     * @param data The data for the request.
     * @param data.requestBody
     * @returns unknown OK
     * @throws ApiError
     */
    public static miningAndFeeding(data: PostApiClicksMiningAndFeedingData = {}): CancelablePromise<PostApiClicksMiningAndFeedingResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Clicks/MiningAndFeeding',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
}

export class CoinsShopService {
    /**
     * @returns CoinShopItemListing OK
     * @throws ApiError
     */
    public static getListings(): CancelablePromise<GetApiCoinsShopGetListingsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/CoinsShop/GetListings'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.requestBody
     * @returns unknown OK
     * @throws ApiError
     */
    public static buyItem(data: PostApiCoinsShopBuyItemData = {}): CancelablePromise<PostApiCoinsShopBuyItemResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/CoinsShop/BuyItem',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @returns ICoinsShopGrain OK
     * @throws ApiError
     */
    public static getCoinsShopGrain(): CancelablePromise<GetApiCoinsShopGetCoinsShopGrainResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/CoinsShop/GetCoinsShopGrain'
        });
    }
    
}

export class ConnectSocialsService {
    /**
     * @returns ConnectedSocials OK
     * @throws ApiError
     */
    public static getConnectedSocials(): CancelablePromise<GetApiConnectSocialsGetConnectedSocialsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/ConnectSocials/GetConnectedSocials'
        });
    }
    
    /**
     * @returns boolean OK
     * @throws ApiError
     */
    public static isTwitterConnected(): CancelablePromise<GetApiConnectSocialsIsTwitterConnectedResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/ConnectSocials/IsTwitterConnected'
        });
    }
    
    /**
     * @returns SocialUrl OK
     * @throws ApiError
     */
    public static connectTwitter(): CancelablePromise<GetApiConnectSocialsConnectTwitterResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/ConnectSocials/ConnectTwitter'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.code
     * @param data.state
     * @returns unknown OK
     * @throws ApiError
     */
    public static connectTwitterCallback(data: GetApiConnectSocialsConnectTwitterCallbackData): CancelablePromise<GetApiConnectSocialsConnectTwitterCallbackResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/ConnectSocials/ConnectTwitterCallback',
            query: {
                Code: data.code,
                State: data.state
            }
        });
    }
    
    /**
     * @returns SocialUrl OK
     * @throws ApiError
     */
    public static connectDiscord(): CancelablePromise<GetApiConnectSocialsConnectDiscordResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/ConnectSocials/ConnectDiscord'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.code
     * @param data.state
     * @returns unknown OK
     * @throws ApiError
     */
    public static connectDiscordCallback(data: GetApiConnectSocialsConnectDiscordCallbackData): CancelablePromise<GetApiConnectSocialsConnectDiscordCallbackResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/ConnectSocials/ConnectDiscordCallback',
            query: {
                Code: data.code,
                State: data.state
            }
        });
    }
    
    /**
     * @returns boolean OK
     * @throws ApiError
     */
    public static isDiscordConnected(): CancelablePromise<GetApiConnectSocialsIsDiscordConnectedResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/ConnectSocials/IsDiscordConnected'
        });
    }
    
    /**
     * @returns SocialUrl OK
     * @throws ApiError
     */
    public static connectZephyrus(): CancelablePromise<GetApiConnectSocialsConnectZephyrusResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/ConnectSocials/ConnectZephyrus'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.code
     * @param data.state
     * @returns unknown OK
     * @throws ApiError
     */
    public static connectZephyrusCallback(data: GetApiConnectSocialsConnectZephyrusCallbackData): CancelablePromise<GetApiConnectSocialsConnectZephyrusCallbackResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/ConnectSocials/ConnectZephyrusCallback',
            query: {
                Code: data.code,
                State: data.state
            }
        });
    }
    
}

export class DailyStreakService {
    /**
     * @returns DailyStreakState OK
     * @throws ApiError
     */
    public static getState(): CancelablePromise<GetApiDailyStreakGetStateResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/DailyStreak/GetState',
            responseTransformer: GetApiDailyStreakGetStateResponseTransformer
        });
    }
    
    /**
     * @returns unknown OK
     * @throws ApiError
     */
    public static claimDailyBonus(): CancelablePromise<PostApiDailyStreakClaimDailyBonusResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/DailyStreak/ClaimDailyBonus'
        });
    }
    
    /**
     * @returns unknown OK
     * @throws ApiError
     */
    public static debugResetStreak(): CancelablePromise<PostApiDailyStreakDebugResetStreakResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/DailyStreak/DebugResetStreak'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.requestBody
     * @returns unknown OK
     * @throws ApiError
     */
    public static setDebugMode(data: PostApiDailyStreakSetDebugModeData = {}): CancelablePromise<PostApiDailyStreakSetDebugModeResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/DailyStreak/SetDebugMode',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
}

export class DebugService {
    /**
     * @returns unknown OK
     * @throws ApiError
     */
    public static ping(): CancelablePromise<GetApiDebugPingPingResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Debug/Ping/ping'
        });
    }
    
    /**
     * @returns unknown OK
     * @throws ApiError
     */
    public static error(): CancelablePromise<GetApiDebugErrorErrorResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Debug/Error/error'
        });
    }
    
    /**
     * @returns unknown OK
     * @throws ApiError
     */
    public static russianRoulette(): CancelablePromise<GetApiDebugRussianRouletteRussianRouletteResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Debug/RussianRoulette/russian-roulette'
        });
    }
    
    /**
     * @returns DebugValues OK
     * @throws ApiError
     */
    public static getDebutValues(): CancelablePromise<GetApiDebugGetDebutValuesResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Debug/GetDebutValues',
            responseTransformer: GetApiDebugGetDebutValuesResponseTransformer
        });
    }
    
    /**
     * @returns boolean OK
     * @throws ApiError
     */
    public static isAutoFeedStarted(): CancelablePromise<GetApiDebugIsAutoFeedStartedResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Debug/IsAutoFeedStarted'
        });
    }
    
    /**
     * @returns unknown OK
     * @throws ApiError
     */
    public static startAutoFeed(): CancelablePromise<PostApiDebugStartAutoFeedResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Debug/StartAutoFeed'
        });
    }
    
    /**
     * @returns unknown OK
     * @throws ApiError
     */
    public static stopAutoFeed(): CancelablePromise<PostApiDebugStopAutoFeedResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Debug/StopAutoFeed'
        });
    }
    
    /**
     * @returns unknown OK
     * @throws ApiError
     */
    public static debugClearData(): CancelablePromise<PostApiDebugDebugClearDataResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Debug/DebugClearData'
        });
    }
    
    /**
     * @returns unknown OK
     * @throws ApiError
     */
    public static debugDeleteShopPurchases(): CancelablePromise<PostApiDebugDebugDeleteShopPurchasesResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Debug/DebugDeleteShopPurchases'
        });
    }
    
    /**
     * @returns unknown OK
     * @throws ApiError
     */
    public static debugFakePurchase(): CancelablePromise<PostApiDebugDebugFakePurchaseResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Debug/DebugFakePurchase'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.requestBody
     * @returns unknown OK
     * @throws ApiError
     */
    public static debugFakePurchaseItem(data: PostApiDebugDebugFakePurchaseItemData = {}): CancelablePromise<PostApiDebugDebugFakePurchaseItemResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Debug/DebugFakePurchaseItem',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @returns unknown OK
     * @throws ApiError
     */
    public static debugDestroyQuests(): CancelablePromise<PostApiDebugDebugDestroyQuestsResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Debug/DebugDestroyQuests'
        });
    }
    
    /**
     * @returns unknown OK
     * @throws ApiError
     */
    public static debugCreateReferee(): CancelablePromise<PostApiDebugDebugCreateRefereeResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Debug/DebugCreateReferee'
        });
    }
    
    /**
     * @returns unknown OK
     * @throws ApiError
     */
    public static debugDestroySocialConnections(): CancelablePromise<PostApiDebugDebugDestroySocialConnectionsResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Debug/DebugDestroySocialConnections'
        });
    }
    
    /**
     * @returns unknown OK
     * @throws ApiError
     */
    public static debugResetCoins(): CancelablePromise<PostApiDebugDebugResetCoinsResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Debug/DebugResetCoins'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.requestBody
     * @returns unknown OK
     * @throws ApiError
     */
    public static debugAddCoins(data: PostApiDebugDebugAddCoinsData = {}): CancelablePromise<PostApiDebugDebugAddCoinsResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Debug/DebugAddCoins',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @returns unknown OK
     * @throws ApiError
     */
    public static debugRechargeEnergy(): CancelablePromise<PostApiDebugDebugRechargeEnergyResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Debug/DebugRechargeEnergy'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.requestBody
     * @returns unknown OK
     * @throws ApiError
     */
    public static debugAddShards(data: PostApiDebugDebugAddShardsData = {}): CancelablePromise<PostApiDebugDebugAddShardsResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Debug/DebugAddShards',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.requestBody
     * @returns unknown OK
     * @throws ApiError
     */
    public static updateDebugConfigSkipOnboarding(data: PostApiDebugUpdateDebugConfigSkipOnboardingData = {}): CancelablePromise<PostApiDebugUpdateDebugConfigSkipOnboardingResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Debug/UpdateDebugConfigSkipOnboarding',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @returns unknown OK
     * @throws ApiError
     */
    public static getDebugConfig(): CancelablePromise<GetApiDebugGetDebugConfigResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Debug/GetDebugConfig'
        });
    }
    
    /**
     * @returns unknown OK
     * @throws ApiError
     */
    public static sendDebugNotification(): CancelablePromise<PostApiDebugSendDebugNotificationResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Debug/SendDebugNotification'
        });
    }
    
}

export class EnergyBallsService {
    /**
     * @returns EnergyBall OK
     * @throws ApiError
     */
    public static getEnergyBallState(): CancelablePromise<GetApiEnergyBallsGetEnergyBallStateResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/EnergyBalls/GetEnergyBallState'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.ballId
     * @param data.requestBody
     * @returns unknown OK
     * @throws ApiError
     */
    public static takeHitsCombo(data: PostApiEnergyBallsTakeHitsComboByBallIdData): CancelablePromise<PostApiEnergyBallsTakeHitsComboByBallIdResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/EnergyBalls/TakeHitsCombo/{ballId}',
            path: {
                ballId: data.ballId
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @returns unknown OK
     * @throws ApiError
     */
    public static debugReset(): CancelablePromise<PostApiEnergyBallsDebugResetResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/EnergyBalls/DebugReset'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.ballId
     * @param data.requestBody
     * @returns unknown OK
     * @throws ApiError
     */
    public static debugTakeHits(data: PostApiEnergyBallsDebugTakeHitsByBallIdData): CancelablePromise<PostApiEnergyBallsDebugTakeHitsByBallIdResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/EnergyBalls/DebugTakeHits/{ballId}',
            path: {
                ballId: data.ballId
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
}

export class GameService {
    /**
     * @returns CoinsSnapshot OK
     * @throws ApiError
     */
    public static updateCoinsSnapshot(): CancelablePromise<PostApiGameUpdateCoinsSnapshotResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Game/UpdateCoinsSnapshot',
            responseTransformer: PostApiGameUpdateCoinsSnapshotResponseTransformer
        });
    }
    
    /**
     * @returns number OK
     * @throws ApiError
     */
    public static coinsEarnedAway(): CancelablePromise<GetApiGameCoinsEarnedAwayResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Game/CoinsEarnedAway'
        });
    }
    
    /**
     * @returns PlayerStateDto OK
     * @throws ApiError
     */
    public static getPlayerState(): CancelablePromise<GetApiGameGetPlayerStateResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Game/GetPlayerState',
            responseTransformer: GetApiGameGetPlayerStateResponseTransformer
        });
    }
    
}

export class InventoryService {
    /**
     * @returns InventoryItem OK
     * @throws ApiError
     */
    public static getInventory(): CancelablePromise<GetApiInventoryGetInventoryResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Inventory/GetInventory'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.requestBody
     * @returns unknown OK
     * @throws ApiError
     */
    public static equipItem(data: PostApiInventoryEquipItemData = {}): CancelablePromise<PostApiInventoryEquipItemResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Inventory/EquipItem',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.requestBody
     * @returns unknown OK
     * @throws ApiError
     */
    public static useItem(data: PostApiInventoryUseItemData = {}): CancelablePromise<PostApiInventoryUseItemResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Inventory/UseItem',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @returns unknown OK
     * @throws ApiError
     */
    public static unequipHat(): CancelablePromise<PostApiInventoryUnequipHatResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Inventory/UnequipHat'
        });
    }
    
}

export class OnboardingService {
    /**
     * @returns OnboardingState OK
     * @throws ApiError
     */
    public static getOnboardingState(): CancelablePromise<GetApiOnboardingGetOnboardingStateResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Onboarding/GetOnboardingState'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.requestBody
     * @returns unknown OK
     * @throws ApiError
     */
    public static selectStarter(data: PostApiOnboardingSelectStarterData = {}): CancelablePromise<PostApiOnboardingSelectStarterResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Onboarding/SelectStarter',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.requestBody
     * @returns unknown OK
     * @throws ApiError
     */
    public static updateStep(data: PostApiOnboardingUpdateStepData = {}): CancelablePromise<PostApiOnboardingUpdateStepResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Onboarding/UpdateStep',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @returns unknown OK
     * @throws ApiError
     */
    public static completeOnboarding(): CancelablePromise<PostApiOnboardingCompleteOnboardingResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Onboarding/CompleteOnboarding'
        });
    }
    
}

export class QuestsService {
    /**
     * @returns PlayerQuestDto OK
     * @throws ApiError
     */
    public static getActiveQuests(): CancelablePromise<GetApiQuestsGetActiveQuestsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Quests/GetActiveQuests',
            responseTransformer: GetApiQuestsGetActiveQuestsResponseTransformer
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.questId
     * @returns PlayerQuestDto OK
     * @throws ApiError
     */
    public static getQuest(data: GetApiQuestsGetQuestByQuestIdData): CancelablePromise<GetApiQuestsGetQuestByQuestIdResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Quests/GetQuest/{questId}',
            path: {
                questId: data.questId
            },
            responseTransformer: GetApiQuestsGetQuestByQuestIdResponseTransformer
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.questId
     * @returns QuestVerificationResult OK
     * @throws ApiError
     */
    public static verifyQuest(data: PostApiQuestsVerifyQuestByQuestIdData): CancelablePromise<PostApiQuestsVerifyQuestByQuestIdResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Quests/VerifyQuest/{questId}',
            path: {
                questId: data.questId
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.questId
     * @returns unknown OK
     * @throws ApiError
     */
    public static moveQuestToVerifiable(data: PostApiQuestsMoveQuestToVerifiableByQuestIdData): CancelablePromise<PostApiQuestsMoveQuestToVerifiableByQuestIdResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Quests/MoveQuestToVerifiable/{questId}',
            path: {
                questId: data.questId
            }
        });
    }
    
}

export class RaffleTicketsService {
    /**
     * @returns GetRaffleTicketsResponse OK
     * @throws ApiError
     */
    public static getRaffleTickets(): CancelablePromise<GetApiRaffleTicketsGetRaffleTicketsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/RaffleTickets/GetRaffleTickets'
        });
    }
    
    /**
     * @returns GetRaffleTicketsResponse OK
     * @throws ApiError
     */
    public static getTicketsSinceFirstSnapshot(): CancelablePromise<GetApiRaffleTicketsGetTicketsSinceFirstSnapshotResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/RaffleTickets/GetTicketsSinceFirstSnapshot'
        });
    }
    
    /**
     * @returns RaffleReward OK
     * @throws ApiError
     */
    public static useRaffleTicket(): CancelablePromise<PostApiRaffleTicketsUseRaffleTicketResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/RaffleTickets/UseRaffleTicket'
        });
    }
    
}

export class ReferralsService {
    /**
     * @returns ReferralCodeResponse OK
     * @throws ApiError
     */
    public static gerReferralCode(): CancelablePromise<GetApiReferralsGerReferralCodeResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Referrals/GerReferralCode'
        });
    }
    
    /**
     * @returns ReferralsManagerState OK
     * @throws ApiError
     */
    public static getReferralsState(): CancelablePromise<GetApiReferralsGetReferralsStateResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Referrals/GetReferralsState'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.page
     * @param data.pageSize
     * @returns RefereeDto OK
     * @throws ApiError
     */
    public static getReferees(data: GetApiReferralsGetRefereesData = {}): CancelablePromise<GetApiReferralsGetRefereesResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Referrals/GetReferees',
            query: {
                page: data.page,
                pageSize: data.pageSize
            }
        });
    }
    
    /**
     * @returns number OK
     * @throws ApiError
     */
    public static getRefereesCount(): CancelablePromise<GetApiReferralsGetRefereesCountResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Referrals/GetRefereesCount'
        });
    }
    
}

export class ReincarnateService {
    /**
     * @returns unknown OK
     * @throws ApiError
     */
    public static reincarnate(): CancelablePromise<PostApiReincarnateReincarnateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Reincarnate/Reincarnate'
        });
    }
    
}

export class ShopService {
    /**
     * @param data The data for the request.
     * @param data.listingId
     * @param data.quantity
     * @returns InitiatePurchaseResponse OK
     * @throws ApiError
     */
    public static initiatePurchase(data: GetApiShopInitiatePurchaseByListingIdData): CancelablePromise<GetApiShopInitiatePurchaseByListingIdResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Shop/InitiatePurchase/{listingId}',
            path: {
                listingId: data.listingId
            },
            query: {
                quantity: data.quantity
            }
        });
    }
    
    /**
     * @returns PlayerShopListing OK
     * @throws ApiError
     */
    public static getShopListings(): CancelablePromise<GetApiShopGetShopListingsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Shop/GetShopListings'
        });
    }
    
    /**
     * @returns PlayerShopListing OK
     * @throws ApiError
     */
    public static getBoosterShopListings(): CancelablePromise<GetApiShopGetBoosterShopListingsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Shop/GetBoosterShopListings'
        });
    }
    
}

export class SpecialSignupTicketsService {
    /**
     * @returns TicketCountResponse OK
     * @throws ApiError
     */
    public static getTicketCount(): CancelablePromise<GetApiSpecialSignupTicketsGetTicketCountResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/SpecialSignupTickets/GetTicketCount'
        });
    }
    
}

export class UpgradesService {
    /**
     * @param data The data for the request.
     * @param data.requestBody
     * @returns PurchasableUpgrade OK
     * @throws ApiError
     */
    public static buyUpgrade(data: PostApiUpgradesBuyUpgradeData = {}): CancelablePromise<PostApiUpgradesBuyUpgradeResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Upgrades/BuyUpgrade',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @returns PurchasableUpgrade OK
     * @throws ApiError
     */
    public static getPurchasableUpgrades(): CancelablePromise<GetApiUpgradesGetPurchasableUpgradesResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Upgrades/GetPurchasableUpgrades'
        });
    }
    
}

export class WalletsService {
    /**
     * @param data The data for the request.
     * @param data.requestBody
     * @returns unknown OK
     * @throws ApiError
     */
    public static updateWallet(data: PostApiWalletsUpdateWalletData = {}): CancelablePromise<PostApiWalletsUpdateWalletResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Wallets/UpdateWallet',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
}

export class WildsCommunicationService {
    /**
     * @returns WildsSignedUrl OK
     * @throws ApiError
     */
    public static getWildsSignedUrl(): CancelablePromise<GetApiWildsCommunicationGetWildsSignedUrlResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/WildsCommunication/GetWildsSignedUrl'
        });
    }
    
    /**
     * @returns UserEggStats OK
     * @throws ApiError
     */
    public static getUserEggStats(): CancelablePromise<GetApiWildsCommunicationGetUserEggStatsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/WildsCommunication/GetUserEggStats'
        });
    }
    
}